import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import Full from "./Full";

export const Header = (props) => {
  const history = useHistory();
  const location = useLocation();
  const isServicePage = location.pathname.startsWith('/service');

  const handleDevisClick = (e) => {
    e.preventDefault();
    if (isServicePage) {
      history.push('/#Devis');
      setTimeout(() => {
        const element = document.querySelector('#Devis');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
    } else {
      const element = document.querySelector('#Devis');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
Votre habitat,<h1 style={{color:'#186d08'}}> notre priorité    </h1>              <span></span>
                </h1>
                <p style={{fontSize:'21px'}}>


                </p>
<div className="d_non">
                <div className="" style={{display:'flex',justifyContent:'center'}}>

                <a
                  href={isServicePage ? "/#Devis" : "#Devis"}
                  className=" page-scroll impr"
                  style={{fontSize:'18px',paddingTop:'16px'}}
                  onClick={handleDevisClick}
                >
Demande Devis
                </a>
                  <div style={{ marginLeft: "18px" }}>
                                            <a href="#contact2" className="impr2" >

                    <Full title="Contactez-nous" className='btn'  border />
                                            </a>

                  </div>


                </div>
</div>


<div className="d_yes">
                <div className="" style={{display:'flex',justifyContent:'center'}}>

                <a
                  href={isServicePage ? "/#Devis" : "#Devis"}
                  className=" page-scroll impr nj"
                  style={{fontSize:'18px',paddingTop:'16px'}}
                  onClick={handleDevisClick}
                >
Demande Devis
                </a>
                                </div>
                <div className="" style={{display:'flex',justifyContent:'center',marginTop:'25px'}}>

                  <div style={{ }}>
                                            <a href="#contact2" className="impr2 nj" >

                    <Full title="Contactez-nous" className='btn'  border />
                                            </a>

                  </div>
                  </div>


</div>

                              <br/>
<br/>
<br/>
<br/>
<br/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
